module.exports = __webpack_public_path__ + "4795e84652c78f7cd66d1d0ae3f962c3.png";